module.exports = __webpack_public_path__ + "media/images/manifesto-flag-19fabb0e4526bbdf072689e4c33fe671.svg";